module.exports = __webpack_public_path__ + "img/talent.a4d15e4d.svg";